<template>
  <div class="ds-pagination">
    <span class="ds-pagination__info">{{ rangeLabel }}</span>
    <div class="ds-pagination__controls">
      <select
        class="ds-field ds-pagination__size"
        :value="pageSize"
        aria-label="Aantal per pagina"
        @change="onPageSizeChange"
      >
        <option v-for="size in pageSizeOptions" :key="size" :value="size">
          {{ size }} per pagina
        </option>
      </select>
      <button
        type="button"
        class="ds-pagination__button"
        aria-label="Eerste pagina"
        :disabled="page <= 1"
        @click="$emit('update:page', 1)"
      >
        «
      </button>
      <button
        type="button"
        class="ds-pagination__button"
        aria-label="Vorige pagina"
        :disabled="page <= 1"
        @click="$emit('update:page', page - 1)"
      >
        ‹
      </button>
      <span class="ds-pagination__page">{{ page }} / {{ totalPages }}</span>
      <button
        type="button"
        class="ds-pagination__button"
        aria-label="Volgende pagina"
        :disabled="page >= totalPages"
        @click="$emit('update:page', page + 1)"
      >
        ›
      </button>
      <button
        type="button"
        class="ds-pagination__button"
        aria-label="Laatste pagina"
        :disabled="page >= totalPages"
        @click="$emit('update:page', totalPages)"
      >
        »
      </button>
    </div>
  </div>
</template>

<script>
// The bar that closes a data table: which slice is on screen, how big a page
// is, and the four steps through them.
//
// It owns no state — the page keeps `page` and `pageSize` because it has to
// slice the rows anyway. Use it with v-model:page and v-model:page-size.

export default {
  name: 'DsPagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    pageSizeOptions: {
      type: Array,
      default: () => [10, 25, 50],
    },
  },
  emits: ['update:page', 'update:pageSize'],
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    rangeLabel() {
      const start = this.total === 0 ? 0 : (this.page - 1) * this.pageSize + 1
      const end = Math.min(this.page * this.pageSize, this.total)
      return `${start}–${end} van ${this.total}`
    },
  },
  methods: {
    onPageSizeChange(event) {
      this.$emit('update:pageSize', Number(event.target.value))
      // A bigger page can put the current one past the end of the list.
      this.$emit('update:page', 1)
    },
  },
}
</script>
